<template>
  <div class="publish">
    <div class="publish_button pointer" @click="$store.commit('showDialog')">
      <img src="@/assets/publish-icon.png" />
      <span>发表</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'publish',
  components: {},
  data () {
    return {}
  },
  created () {
  },
  mounted () {
  },
  computed: {},
  methods: {},
  watch: {}
}
</script>

<style scoped>
  .publish { width: 300px; height: 180px; border-radius: 2px; border: 1px solid #DCDFE6; position: relative; }
  .publish .publish_button { width: 160px; height: 62px; line-height: 62px; text-align: center; background: #76BF28; border-radius: 6px; position: absolute; top: 50%; left: 50%; margin-top: -31px; margin-left: -80px; }
  .publish .publish_button img { width: 18px; height: 18px; margin-right: 5px; }
  .publish .publish_button span { font-size:16px; color: #FFFFFF; }
  .publish .publish_button:hover { background-color: #65A422; }
</style>



// WEBPACK FOOTER //
// src/components/contact/publish.vue